import { type FC } from 'react'

import divisionLarge from '@core/assets/v2/icons/math/regular/Icon-Division-Large-Regular.svg'
import equalLarge from '@core/assets/v2/icons/math/regular/Icon-Equal-Large-Regular.svg'
import equal from '@core/assets/v2/icons/math/regular/Icon-Equal-Regular.svg'
import minusCircle from '@core/assets/v2/icons/math/regular/Icon-Minus-Circle-Regular.svg'
import minusLarge from '@core/assets/v2/icons/math/regular/Icon-Minus-Large-Regular.svg'
import minusSmall from '@core/assets/v2/icons/math/regular/Icon-Minus-Small-Regular.svg'
import plusCircle from '@core/assets/v2/icons/math/regular/Icon-Plus-Circle-Regular.svg'
import plusLarge from '@core/assets/v2/icons/math/regular/Icon-Plus-Large-Regular.svg'
import plusSmall from '@core/assets/v2/icons/math/regular/Icon-Plus-Small-Regular.svg'
import plusAndMinus from '@core/assets/v2/icons/math/regular/Icon-PlusAndMinus-Regular.svg'
import slashLarge from '@core/assets/v2/icons/math/regular/Icon-Slash-Large-Regular.svg'
import xLarge from '@core/assets/v2/icons/math/regular/Icon-X-Large-Regular.svg'
import xSmall from '@core/assets/v2/icons/math/regular/Icon-X-Small-Regular.svg'

import { createIcon } from './createIcon'
import type { IconProps, MathIconName } from './types'

export const IconDivisionLarge = createIcon(divisionLarge, 'DivisionLarge')
export const IconEqualLarge = createIcon(equalLarge, 'EqualLarge')
export const IconEqual = createIcon(equal, 'Equal')
export const IconMinusCircle = createIcon(minusCircle, 'MinusCircle')
export const IconMinusLarge = createIcon(minusLarge, 'MinusLarge')
export const IconMinusSmall = createIcon(minusSmall, 'MinusSmall')
export const IconPlusCircle = createIcon(plusCircle, 'PlusCircle')
export const IconPlusLarge = createIcon(plusLarge, 'PlusLarge')
export const IconPlusSmall = createIcon(plusSmall, 'PlusSmall')
export const IconPlusAndMinus = createIcon(plusAndMinus, 'PlusAndMinus')
export const IconSlashLarge = createIcon(slashLarge, 'SlashLarge')
export const IconXLarge = createIcon(xLarge, 'XLarge')
export const IconXSmall = createIcon(xSmall, 'XSmall')

export const mathIcons: Record<MathIconName, FC<IconProps>> = {
    DivisionLarge: IconDivisionLarge,
    EqualLarge: IconEqualLarge,
    Equal: IconEqual,
    MinusCircle: IconMinusCircle,
    MinusLarge: IconMinusLarge,
    MinusSmall: IconMinusSmall,
    PlusCircle: IconPlusCircle,
    PlusLarge: IconPlusLarge,
    PlusSmall: IconPlusSmall,
    PlusAndMinus: IconPlusAndMinus,
    SlashLarge: IconSlashLarge,
    XLarge: IconXLarge,
    XSmall: IconXSmall,
}
